// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Enhanced Chat Input Styles */
.enhanced-chat-input-container {
  position: relative;
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
  padding: 0 16px;
}

/* Reply Banner */
.reply-banner {
  background: var(--bg-secondary);
  border: 1px solid var(--border-primary);
  border-radius: 12px 12px 0 0;
  padding: 12px 16px;
  margin: 0 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  color: var(--text-secondary);
}

.reply-content {
  display: flex;
  align-items: center;
  gap: 8px;
}

.cancel-reply {
  background: none;
  border: none;
  color: var(--text-tertiary);
  cursor: pointer;
  padding: 4px;
  border-radius: 6px;
  transition: all 0.2s ease;
}

.cancel-reply:hover {
  background: var(--bg-secondary);
  color: var(--text-secondary);
}

/* Floating Upload Section */
.floating-upload-section {
  background: var(--bg-primary);
  border: 1px solid var(--border-primary);
  border-radius: 16px;
  margin-bottom: 12px;
  padding: 20px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  animation: slideUpFade 0.2s ease-out;
}

[data-theme="dark"] .floating-upload-section {
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
}

/* Floating Documents Section */
.floating-documents-section {
  background: var(--bg-primary);
  border: 1px solid var(--border-primary);
  border-radius: 16px;
  margin-bottom: 12px;
  max-height: 400px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  animation: slideUpFade 0.2s ease-out;
}

[data-theme="dark"] .floating-documents-section {
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
}

.documents-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid var(--border-primary);
  background: var(--bg-secondary);
}

.documents-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 500;
  color: var(--text-primary);
  font-size: 14px;
}

.close-documents-btn {
  background: none;
  border: none;
  color: var(--text-tertiary);
  cursor: pointer;
  padding: 6px;
  border-radius: 6px;
  transition: all 0.2s ease;
}

.close-documents-btn:hover {
  background: var(--bg-tertiary);
  color: var(--text-secondary);
}

.documents-list {
  max-height: 300px;
  overflow-y: auto;
  padding: 8px;
}

.no-documents {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  text-align: center;
  color: var(--text-tertiary);
}

.no-documents svg {
  margin-bottom: 12px;
  opacity: 0.5;
}

.no-documents p {
  margin: 8px 0;
  font-weight: 500;
  color: var(--text-primary);
}

.no-documents span {
  font-size: 13px;
  color: var(--text-tertiary);
}

.document-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  border-radius: 8px;
  transition: background-color 0.2s ease;
}

.document-item:hover {
  background: var(--bg-secondary);
}

.document-icon {
  font-size: 20px;
  flex-shrink: 0;
}

.document-info {
  flex: 1 1;
  min-width: 0;
}

.document-name {
  font-weight: 500;
  color: var(--text-primary);
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.document-details {
  font-size: 12px;
  color: var(--text-secondary);
  margin-top: 2px;
}

.document-actions {
  display: flex;
  gap: 4px;
}

.document-action-btn {
  background: none;
  border: none;
  color: var(--text-tertiary);
  cursor: pointer;
  padding: 6px;
  border-radius: 4px;
  transition: all 0.2s ease;
}

.document-action-btn:hover {
  background: var(--bg-tertiary);
  color: var(--text-secondary);
}

.document-action-btn:hover:has(svg[data-icon="trash-2"]) {
  background: #FEF2F2;
  color: #DC2626;
}

[data-theme="dark"] .document-action-btn:hover:has(svg[data-icon="trash-2"]) {
  background: #7F1D1D;
  color: #FCA5A5;
}

/* Main Input Box */
.floating-input-box {
  background: var(--bg-primary);
  border: 1px solid var(--border-primary);
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  overflow: hidden;
  transition: all 0.2s ease;
}

[data-theme="dark"] .floating-input-box {
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);
}

.floating-input-box:focus-within {
  border-color: var(--accent-primary);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.16), 0 0 0 1px var(--accent-primary);
}

[data-theme="dark"] .floating-input-box:focus-within {
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5), 0 0 0 1px var(--accent-primary);
}

/* Text Input Row */
.text-input-row {
  padding: 16px 20px 4px 20px;
}

.main-textarea {
  width: 100%;
  min-height: 24px;
  max-height: 200px;
  border: none;
  outline: none;
  resize: none;
  background: transparent;
  color: var(--text-primary);
  font-size: 16px;
  font-family: inherit;
  line-height: 1.5;
  overflow-y: auto;
}

.main-textarea::placeholder {
  color: var(--text-tertiary);
}

/* Controls Row */
.controls-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 20px 16px 20px;
}

/* File Controls - ensure buttons stay side by side */
.file-controls {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: nowrap;
}

/* Add Documents Button */
.add-docs-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  background: var(--bg-secondary);
  border: 1px solid var(--border-secondary);
  border-radius: 8px;
  padding: 8px 12px;
  font-size: 14px;
  font-weight: 500;
  color: var(--text-secondary);
  cursor: pointer;
  transition: all 0.2s ease;
}

.add-docs-btn:hover:not(:disabled) {
  background: var(--bg-tertiary);
  border-color: var(--border-primary);
  color: var(--text-primary);
}

.add-docs-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.add-docs-btn.active {
  background: var(--accent-primary);
  border-color: var(--accent-primary);
  color: white;
}

/* View Documents Button */
.view-docs-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  background: var(--bg-secondary);
  border: 1px solid var(--border-secondary);
  border-radius: 8px;
  padding: 8px 10px;
  color: var(--text-secondary);
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;
}

.view-docs-btn:hover {
  background: var(--bg-tertiary);
  border-color: var(--border-primary);
  color: var(--text-primary);
}

.view-docs-btn.active {
  background: var(--accent-primary);
  border-color: var(--accent-primary);
  color: white;
}

.docs-count {
  background: var(--accent-primary);
  color: white;
  border-radius: 10px;
  padding: 2px 6px;
  font-size: 10px;
  font-weight: 700;
  min-width: 16px;
  text-align: center;
  line-height: 1.2;
}

.view-docs-btn:hover .docs-count,
.view-docs-btn.active .docs-count {
  background: white;
  color: var(--accent-primary);
}

/* Send Button - FIXED VERSION */
.send-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;
  flex-shrink: 0;
}

/* Enabled state - clean approach */
.send-button.enabled {
  background: #3B82F6;
  color: #FFFFFF;
  box-shadow: 0 2px 8px rgba(59, 130, 246, 0.3);
}

/* Icon styling - use currentColor for better inheritance */
.send-button svg {
  width: 16px;
  height: 16px;
  color: currentColor;
}

.send-button.enabled:hover {
  background: #2563EB;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.4);
}

.send-button.enabled:active {
  transform: translateY(0);
  box-shadow: 0 2px 8px rgba(59, 130, 246, 0.3);
}

/* Disabled state */
.send-button.disabled {
  background: #E5E7EB;
  color: #9CA3AF;
  cursor: not-allowed;
  box-shadow: none;
}

[data-theme="dark"] .send-button.disabled {
  background: #374151;
  color: #6B7280;
}

/* Document Upload Notifications */
.document-upload-notification {
  display: flex;
  justify-content: center;
  margin: 16px 0;
  animation: slideUpFade 0.3s ease-out;
  background: transparent;
  box-shadow: none;
  border: none;
  padding: 0;
}

/* [data-theme="dark"] .document-upload-notification {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
} */

.upload-notification-content {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  background: var(--feature-bg);  /* Change from fixed color */
  border: 1px solid var(--accent-primary);  /* Change from fixed color */
  border-radius: 12px;
  color: var(--accent-primary);  /* Change from fixed color */
  font-size: 14px;
  font-weight: 500;
  max-width: 80%;
}

.upload-notification-icon {
  flex-shrink: 0;
}

.upload-notification-icon.success {
  color: #10B981;
}

.upload-notification-icon.error {
  color: #EF4444;
}

.upload-notification-text {
  flex: 1 1;
}

.upload-notification-title {
  font-weight: 500;
  color: var(--text-primary);
  margin: 0 0 2px 0;
  font-size: 14px;
}

.upload-notification-message {
  color: var(--text-secondary);
  margin: 0;
  font-size: 13px;
}

/* [data-theme="dark"] .upload-notification-content {
  box-shadow: 0 4px 16px rgba(99, 102, 241, 0.25);
} */

.notification-close-btn {
  background: none;
  border: none;
  color: var(--text-tertiary);
  cursor: pointer;
  padding: 4px;
  border-radius: 6px;
  transition: all 0.2s ease;
}

.notification-close-btn:hover {
  background: var(--bg-secondary);
  color: var(--text-secondary);
}

/* Animations */
@keyframes slideUpFade {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Mobile Responsive */
@media (max-width: 768px) {
  .enhanced-chat-input-container {
    padding: 0 12px;
  }
  
  .text-input-row {
    padding: 14px 16px 4px 16px;
  }
  
  .controls-row {
    padding: 8px 16px 14px 16px;
  }
  
  .main-textarea {
    font-size: 16px; /* Prevents zoom on iOS */
  }
  
  .add-docs-btn {
    padding: 6px 10px;
    font-size: 13px;
  }
  
  .add-docs-btn span {
    display: none; /* Hide text on mobile, show only icon */
  }
  
  .view-docs-btn {
    padding: 6px 8px;
  }
  
  .send-button {
    width: 32px;
    height: 32px;
  }
  
  .floating-upload-section,
  .floating-documents-section {
    padding: 16px;
  }
  
  .documents-header {
    padding: 12px 16px;
  }
  
  .documents-list {
    max-height: 250px;
  }
  
  .upload-notification-content {
    max-width: 95%;
    padding: 10px 14px;
    font-size: 13px;
  }
  
  .reply-banner {
    margin: 0 12px 12px 12px;
  }
}

/* Focus and accessibility */
.add-docs-btn:focus-visible,
.view-docs-btn:focus-visible,
.send-button:focus-visible {
  outline: 2px solid var(--accent-primary);
  outline-offset: 2px;
}

.main-textarea:focus {
  outline: none; /* Handled by parent container */
}

/* Loading states */
.floating-input-box.loading {
  opacity: 0.7;
  pointer-events: none;
}

.main-textarea.loading {
  cursor: wait;
}

/* High contrast mode support */
@media (prefers-contrast: high) {
  .floating-input-box {
    border-width: 2px;
  }
  
  .send-button.enabled {
    border: 2px solid #3B82F6;
  }
}

/* Reduced motion support */
@media (prefers-reduced-motion: reduce) {
  .floating-input-box,
  .add-docs-btn,
  .view-docs-btn,
  .send-button,
  .floating-upload-section,
  .floating-documents-section {
    transition: none;
  }
  
  .slideUpFade {
    animation: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/EnhancedChatInput.css"],"names":[],"mappings":"AAAA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,+BAA+B;EAC/B,uCAAuC;EACvC,4BAA4B;EAC5B,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,2BAA2B;EAC3B,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA,4BAA4B;AAC5B;EACE,6BAA6B;EAC7B,uCAAuC;EACvC,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,yCAAyC;EACzC,oCAAoC;AACtC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA,+BAA+B;AAC/B;EACE,6BAA6B;EAC7B,uCAAuC;EACvC,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,yCAAyC;EACzC,oCAAoC;AACtC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,8CAA8C;EAC9C,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,2BAA2B;EAC3B,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,2BAA2B;EAC3B,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,6BAA6B;EAC7B,uCAAuC;EACvC,mBAAmB;EACnB,0CAA0C;EAC1C,2BAA2B;EAC3B,mCAAmC;EACnC,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,mCAAmC;EACnC,2EAA2E;AAC7E;;AAEA;EACE,0EAA0E;AAC5E;;AAEA,mBAAmB;AACnB;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,0BAA0B;EAC1B,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA,qDAAqD;AACrD;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;AACnB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,+BAA+B;EAC/B,yCAAyC;EACzC,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,mCAAmC;EACnC,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,mCAAmC;EACnC,YAAY;AACd;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,+BAA+B;EAC/B,yCAAyC;EACzC,kBAAkB;EAClB,iBAAiB;EACjB,4BAA4B;EAC5B,eAAe;EACf,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,mCAAmC;EACnC,0BAA0B;AAC5B;;AAEA;EACE,iCAAiC;EACjC,mCAAmC;EACnC,YAAY;AACd;;AAEA;EACE,iCAAiC;EACjC,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;AAChB;;AAEA,mCAAmC;AACnC;EACE,mBAAmB;EACnB,cAAc;EACd,6CAA6C;AAC/C;;AAEA,2DAA2D;AAC3D;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,wBAAwB;EACxB,6CAA6C;AAC/C;;AAEA,mBAAmB;AACnB;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,uBAAuB;EACvB,cAAc;EACd,oCAAoC;EACpC,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,UAAU;AACZ;;AAEA;;GAEG;;AAEH;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,6BAA6B,GAAG,4BAA4B;EAC5D,uCAAuC,GAAG,4BAA4B;EACtE,mBAAmB;EACnB,4BAA4B,GAAG,4BAA4B;EAC3D,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,SAAS;EACT,eAAe;AACjB;;AAEA;;GAEG;;AAEH;EACE,gBAAgB;EAChB,YAAY;EACZ,2BAA2B;EAC3B,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA,eAAe;AACf;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,eAAe;EACjB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,eAAe,EAAE,yBAAyB;EAC5C;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,aAAa,EAAE,wCAAwC;EACzD;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA,4BAA4B;AAC5B;;;EAGE,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,aAAa,EAAE,gCAAgC;AACjD;;AAEA,mBAAmB;AACnB;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,YAAY;AACd;;AAEA,+BAA+B;AAC/B;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA,2BAA2B;AAC3B;EACE;;;;;;IAME,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* Enhanced Chat Input Styles */\n.enhanced-chat-input-container {\n  position: relative;\n  width: 100%;\n  max-width: 800px;\n  margin: 0 auto;\n  padding: 0 16px;\n}\n\n/* Reply Banner */\n.reply-banner {\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-primary);\n  border-radius: 12px 12px 0 0;\n  padding: 12px 16px;\n  margin: 0 16px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  font-size: 14px;\n  color: var(--text-secondary);\n}\n\n.reply-content {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.cancel-reply {\n  background: none;\n  border: none;\n  color: var(--text-tertiary);\n  cursor: pointer;\n  padding: 4px;\n  border-radius: 6px;\n  transition: all 0.2s ease;\n}\n\n.cancel-reply:hover {\n  background: var(--bg-secondary);\n  color: var(--text-secondary);\n}\n\n/* Floating Upload Section */\n.floating-upload-section {\n  background: var(--bg-primary);\n  border: 1px solid var(--border-primary);\n  border-radius: 16px;\n  margin-bottom: 12px;\n  padding: 20px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\n  animation: slideUpFade 0.2s ease-out;\n}\n\n[data-theme=\"dark\"] .floating-upload-section {\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);\n}\n\n/* Floating Documents Section */\n.floating-documents-section {\n  background: var(--bg-primary);\n  border: 1px solid var(--border-primary);\n  border-radius: 16px;\n  margin-bottom: 12px;\n  max-height: 400px;\n  overflow: hidden;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\n  animation: slideUpFade 0.2s ease-out;\n}\n\n[data-theme=\"dark\"] .floating-documents-section {\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);\n}\n\n.documents-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 20px;\n  border-bottom: 1px solid var(--border-primary);\n  background: var(--bg-secondary);\n}\n\n.documents-title {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-weight: 500;\n  color: var(--text-primary);\n  font-size: 14px;\n}\n\n.close-documents-btn {\n  background: none;\n  border: none;\n  color: var(--text-tertiary);\n  cursor: pointer;\n  padding: 6px;\n  border-radius: 6px;\n  transition: all 0.2s ease;\n}\n\n.close-documents-btn:hover {\n  background: var(--bg-tertiary);\n  color: var(--text-secondary);\n}\n\n.documents-list {\n  max-height: 300px;\n  overflow-y: auto;\n  padding: 8px;\n}\n\n.no-documents {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 40px 20px;\n  text-align: center;\n  color: var(--text-tertiary);\n}\n\n.no-documents svg {\n  margin-bottom: 12px;\n  opacity: 0.5;\n}\n\n.no-documents p {\n  margin: 8px 0;\n  font-weight: 500;\n  color: var(--text-primary);\n}\n\n.no-documents span {\n  font-size: 13px;\n  color: var(--text-tertiary);\n}\n\n.document-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px;\n  border-radius: 8px;\n  transition: background-color 0.2s ease;\n}\n\n.document-item:hover {\n  background: var(--bg-secondary);\n}\n\n.document-icon {\n  font-size: 20px;\n  flex-shrink: 0;\n}\n\n.document-info {\n  flex: 1;\n  min-width: 0;\n}\n\n.document-name {\n  font-weight: 500;\n  color: var(--text-primary);\n  font-size: 14px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.document-details {\n  font-size: 12px;\n  color: var(--text-secondary);\n  margin-top: 2px;\n}\n\n.document-actions {\n  display: flex;\n  gap: 4px;\n}\n\n.document-action-btn {\n  background: none;\n  border: none;\n  color: var(--text-tertiary);\n  cursor: pointer;\n  padding: 6px;\n  border-radius: 4px;\n  transition: all 0.2s ease;\n}\n\n.document-action-btn:hover {\n  background: var(--bg-tertiary);\n  color: var(--text-secondary);\n}\n\n.document-action-btn:hover:has(svg[data-icon=\"trash-2\"]) {\n  background: #FEF2F2;\n  color: #DC2626;\n}\n\n[data-theme=\"dark\"] .document-action-btn:hover:has(svg[data-icon=\"trash-2\"]) {\n  background: #7F1D1D;\n  color: #FCA5A5;\n}\n\n/* Main Input Box */\n.floating-input-box {\n  background: var(--bg-primary);\n  border: 1px solid var(--border-primary);\n  border-radius: 16px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);\n  backdrop-filter: blur(20px);\n  -webkit-backdrop-filter: blur(20px);\n  overflow: hidden;\n  transition: all 0.2s ease;\n}\n\n[data-theme=\"dark\"] .floating-input-box {\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);\n}\n\n.floating-input-box:focus-within {\n  border-color: var(--accent-primary);\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.16), 0 0 0 1px var(--accent-primary);\n}\n\n[data-theme=\"dark\"] .floating-input-box:focus-within {\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5), 0 0 0 1px var(--accent-primary);\n}\n\n/* Text Input Row */\n.text-input-row {\n  padding: 16px 20px 4px 20px;\n}\n\n.main-textarea {\n  width: 100%;\n  min-height: 24px;\n  max-height: 200px;\n  border: none;\n  outline: none;\n  resize: none;\n  background: transparent;\n  color: var(--text-primary);\n  font-size: 16px;\n  font-family: inherit;\n  line-height: 1.5;\n  overflow-y: auto;\n}\n\n.main-textarea::placeholder {\n  color: var(--text-tertiary);\n}\n\n/* Controls Row */\n.controls-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 8px 20px 16px 20px;\n}\n\n/* File Controls - ensure buttons stay side by side */\n.file-controls {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: nowrap;\n}\n\n/* Add Documents Button */\n.add-docs-btn {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-secondary);\n  border-radius: 8px;\n  padding: 8px 12px;\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--text-secondary);\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.add-docs-btn:hover:not(:disabled) {\n  background: var(--bg-tertiary);\n  border-color: var(--border-primary);\n  color: var(--text-primary);\n}\n\n.add-docs-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.add-docs-btn.active {\n  background: var(--accent-primary);\n  border-color: var(--accent-primary);\n  color: white;\n}\n\n/* View Documents Button */\n.view-docs-btn {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-secondary);\n  border-radius: 8px;\n  padding: 8px 10px;\n  color: var(--text-secondary);\n  cursor: pointer;\n  transition: all 0.2s ease;\n  position: relative;\n}\n\n.view-docs-btn:hover {\n  background: var(--bg-tertiary);\n  border-color: var(--border-primary);\n  color: var(--text-primary);\n}\n\n.view-docs-btn.active {\n  background: var(--accent-primary);\n  border-color: var(--accent-primary);\n  color: white;\n}\n\n.docs-count {\n  background: var(--accent-primary);\n  color: white;\n  border-radius: 10px;\n  padding: 2px 6px;\n  font-size: 10px;\n  font-weight: 700;\n  min-width: 16px;\n  text-align: center;\n  line-height: 1.2;\n}\n\n.view-docs-btn:hover .docs-count,\n.view-docs-btn.active .docs-count {\n  background: white;\n  color: var(--accent-primary);\n}\n\n/* Send Button - FIXED VERSION */\n.send-button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  border-radius: 8px;\n  border: none;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  position: relative;\n  flex-shrink: 0;\n}\n\n/* Enabled state - clean approach */\n.send-button.enabled {\n  background: #3B82F6;\n  color: #FFFFFF;\n  box-shadow: 0 2px 8px rgba(59, 130, 246, 0.3);\n}\n\n/* Icon styling - use currentColor for better inheritance */\n.send-button svg {\n  width: 16px;\n  height: 16px;\n  color: currentColor;\n}\n\n.send-button.enabled:hover {\n  background: #2563EB;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.4);\n}\n\n.send-button.enabled:active {\n  transform: translateY(0);\n  box-shadow: 0 2px 8px rgba(59, 130, 246, 0.3);\n}\n\n/* Disabled state */\n.send-button.disabled {\n  background: #E5E7EB;\n  color: #9CA3AF;\n  cursor: not-allowed;\n  box-shadow: none;\n}\n\n[data-theme=\"dark\"] .send-button.disabled {\n  background: #374151;\n  color: #6B7280;\n}\n\n/* Document Upload Notifications */\n.document-upload-notification {\n  display: flex;\n  justify-content: center;\n  margin: 16px 0;\n  animation: slideUpFade 0.3s ease-out;\n  background: transparent;\n  box-shadow: none;\n  border: none;\n  padding: 0;\n}\n\n/* [data-theme=\"dark\"] .document-upload-notification {\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);\n} */\n\n.upload-notification-content {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 16px;\n  background: var(--feature-bg);  /* Change from fixed color */\n  border: 1px solid var(--accent-primary);  /* Change from fixed color */\n  border-radius: 12px;\n  color: var(--accent-primary);  /* Change from fixed color */\n  font-size: 14px;\n  font-weight: 500;\n  max-width: 80%;\n}\n\n.upload-notification-icon {\n  flex-shrink: 0;\n}\n\n.upload-notification-icon.success {\n  color: #10B981;\n}\n\n.upload-notification-icon.error {\n  color: #EF4444;\n}\n\n.upload-notification-text {\n  flex: 1;\n}\n\n.upload-notification-title {\n  font-weight: 500;\n  color: var(--text-primary);\n  margin: 0 0 2px 0;\n  font-size: 14px;\n}\n\n.upload-notification-message {\n  color: var(--text-secondary);\n  margin: 0;\n  font-size: 13px;\n}\n\n/* [data-theme=\"dark\"] .upload-notification-content {\n  box-shadow: 0 4px 16px rgba(99, 102, 241, 0.25);\n} */\n\n.notification-close-btn {\n  background: none;\n  border: none;\n  color: var(--text-tertiary);\n  cursor: pointer;\n  padding: 4px;\n  border-radius: 6px;\n  transition: all 0.2s ease;\n}\n\n.notification-close-btn:hover {\n  background: var(--bg-secondary);\n  color: var(--text-secondary);\n}\n\n/* Animations */\n@keyframes slideUpFade {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Mobile Responsive */\n@media (max-width: 768px) {\n  .enhanced-chat-input-container {\n    padding: 0 12px;\n  }\n  \n  .text-input-row {\n    padding: 14px 16px 4px 16px;\n  }\n  \n  .controls-row {\n    padding: 8px 16px 14px 16px;\n  }\n  \n  .main-textarea {\n    font-size: 16px; /* Prevents zoom on iOS */\n  }\n  \n  .add-docs-btn {\n    padding: 6px 10px;\n    font-size: 13px;\n  }\n  \n  .add-docs-btn span {\n    display: none; /* Hide text on mobile, show only icon */\n  }\n  \n  .view-docs-btn {\n    padding: 6px 8px;\n  }\n  \n  .send-button {\n    width: 32px;\n    height: 32px;\n  }\n  \n  .floating-upload-section,\n  .floating-documents-section {\n    padding: 16px;\n  }\n  \n  .documents-header {\n    padding: 12px 16px;\n  }\n  \n  .documents-list {\n    max-height: 250px;\n  }\n  \n  .upload-notification-content {\n    max-width: 95%;\n    padding: 10px 14px;\n    font-size: 13px;\n  }\n  \n  .reply-banner {\n    margin: 0 12px 12px 12px;\n  }\n}\n\n/* Focus and accessibility */\n.add-docs-btn:focus-visible,\n.view-docs-btn:focus-visible,\n.send-button:focus-visible {\n  outline: 2px solid var(--accent-primary);\n  outline-offset: 2px;\n}\n\n.main-textarea:focus {\n  outline: none; /* Handled by parent container */\n}\n\n/* Loading states */\n.floating-input-box.loading {\n  opacity: 0.7;\n  pointer-events: none;\n}\n\n.main-textarea.loading {\n  cursor: wait;\n}\n\n/* High contrast mode support */\n@media (prefers-contrast: high) {\n  .floating-input-box {\n    border-width: 2px;\n  }\n  \n  .send-button.enabled {\n    border: 2px solid #3B82F6;\n  }\n}\n\n/* Reduced motion support */\n@media (prefers-reduced-motion: reduce) {\n  .floating-input-box,\n  .add-docs-btn,\n  .view-docs-btn,\n  .send-button,\n  .floating-upload-section,\n  .floating-documents-section {\n    transition: none;\n  }\n  \n  .slideUpFade {\n    animation: none;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
